"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _path = _interopRequireDefault(require("path"));

var _utils = require("./utils");

var _filesystemUploadDirectory = _interopRequireDefault(require("./filesystem-upload-directory"));

var _filesystemUploadAsset = _interopRequireDefault(require("./filesystem-upload-asset"));

var _filesystemUploadUtils = require("./filesystem-upload-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Keeps track of FileSystemUploadDirectory and FileSystemUploadAsset
 * instances that have been retrieved using the manager. Its primary
 * purpose is to ensure that an instance for any given path is only
 * created once, then reused thereafter. It will also automatically
 * create necessary instances for parent directories up until the 
 * manager's root path.
 */
var FileSystemUploadItemManager = /*#__PURE__*/function () {
  /**
   * Constructs a new, empty instance of the manager that will use
   * a the given information.
   * @param {FileSystemUploadOptions} uploadOptions Will be given to
   *  each FileSystemUploadDirectory instance that is created.
   * @param {string} rootPath The top-most path that the manager
   *  will track.
   * @param {boolean} [keepFlat] If true, assets retrieved through
   *  the item manager will be kept at the root of the upload instead
   *  of inside its parent directory. Default: false.
   */
  function FileSystemUploadItemManager(uploadOptions, rootPath) {
    var keepFlat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, FileSystemUploadItemManager);

    this.uploadOptions = uploadOptions;
    this.directories = new Map();
    this.assets = new Map();
    this.rootPath = (0, _utils.normalizePath)(rootPath);
    this.keepFlat = keepFlat;
  }
  /**
   * Retrieves an instance of FileSystemUploadDirectory for a given local path.
   * The method will cache the instance, if necessary, and will also ensure that
   * all parent instances up to the manager's root are also cached.
   * @param {string} localPath Directory path whose information will be used
   *  to create the FileSystemUploadDirectory instance.
   * @returns {Promise} Resolved with a FileSystemUploadDirectory instance
   *  representing of the given directory path.
   */


  _createClass(FileSystemUploadItemManager, [{
    key: "getDirectory",
    value: function () {
      var _getDirectory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(localPath) {
        var normalizedPath, parent, nodeName;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                normalizedPath = (0, _utils.normalizePath)(localPath);
                _context.next = 3;
                return (0, _filesystemUploadUtils.getItemManagerParent)(this, this.rootPath, localPath);

              case 3:
                parent = _context.sent;

                if (this.directories.has(normalizedPath)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return (0, _filesystemUploadUtils.cleanFolderName)(this.uploadOptions, _path.default.basename(normalizedPath));

              case 7:
                nodeName = _context.sent;
                this.directories.set(normalizedPath, new _filesystemUploadDirectory.default(this.uploadOptions, normalizedPath, nodeName, parent));

              case 9:
                return _context.abrupt("return", this.directories.get(normalizedPath));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getDirectory(_x) {
        return _getDirectory.apply(this, arguments);
      }

      return getDirectory;
    }()
    /**
     * Retrieves an instance of FileSystemUploadAsset for a given local path.
     * The method will cache the instance, if necessary, and will also ensure that
     * all parent instances up to the manager's root are also cached.
     * @param {string} localPath Asset path whose information will be used
     *  to create the FileSystemUploadAsset instance.
     * @param {number} size Size, in bytes, of the asset.
     * @returns {Promise} Resolved with a FileSystemUploadAsset instance
     *  representing of the given asset path.
     */

  }, {
    key: "getAsset",
    value: function () {
      var _getAsset = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(localPath, size) {
        var normalizedPath, parent, nodeName;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                normalizedPath = (0, _utils.normalizePath)(localPath);

                if (this.keepFlat) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 4;
                return (0, _filesystemUploadUtils.getItemManagerParent)(this, this.rootPath, localPath);

              case 4:
                _context2.t0 = _context2.sent;
                _context2.next = 8;
                break;

              case 7:
                _context2.t0 = undefined;

              case 8:
                parent = _context2.t0;

                if (this.assets.has(normalizedPath)) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 12;
                return (0, _filesystemUploadUtils.cleanAssetName)(this.uploadOptions, _path.default.basename(normalizedPath));

              case 12:
                nodeName = _context2.sent;
                this.assets.set(normalizedPath, new _filesystemUploadAsset.default(this.uploadOptions, normalizedPath, nodeName, size, parent));

              case 14:
                return _context2.abrupt("return", this.assets.get(normalizedPath));

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAsset(_x2, _x3) {
        return _getAsset.apply(this, arguments);
      }

      return getAsset;
    }()
    /**
     * Retrieves a value indicating whether the given local directory path
     * has been cached in the manager.
     * @param {string} localPath Full path to a local directory.
     * @returns {boolean} True if the directory is cached, false otherwise.
     */

  }, {
    key: "hasDirectory",
    value: function hasDirectory(localPath) {
      return this.directories.has((0, _utils.normalizePath)(localPath));
    }
    /**
     * Retrieves a value indicating whether the given local asset path
     * has been cached in the manager.
     * @param {string} localPath Full path to a local asset.
     * @returns {boolean} True if the asset is cached, false otherwise.
     */

  }, {
    key: "hasAsset",
    value: function hasAsset(localPath) {
      return this.assets.has((0, _utils.normalizePath)(localPath));
    }
  }]);

  return FileSystemUploadItemManager;
}();

exports.default = FileSystemUploadItemManager;